// Grilles de vignettes : chaque case peut empiler plusieurs faces, ce
// module les fait alterner en vague diagonale. Le délai d'une case
// dépend de sa position (ligne + colonne) dans la grille : le CSS seul
// ne sait pas le calculer, puisque le nombre de colonnes passe de 2 à 4
// au breakpoint « tablet ».
(function () {
  "use strict";

  // Décalage entre deux cases voisines de la vague.
  var STEP = 110;
  // Période entre deux vagues (la vague elle-même dure ~0,9 s).
  var CYCLE = 6000;
  // Temps d'affichage du 1er état avant la toute première vague. Compté
  // à partir du moment où la grille atteint la bande centrale du viewport
  // (cf. ROOT_MARGIN), pas dès qu'elle pointe en bas de l'écran : le délai
  // ressenti ne dépend donc plus de la vitesse de défilement.
  var FIRST_WAVE = 4000;
  // L'observateur ne considère que la moitié centrale du viewport. Un
  // pourcentage de visibilité (`threshold`) ne conviendrait pas : une grille
  // plus haute que l'écran ne l'atteindrait jamais et ne démarrerait jamais.
  // Tout élément qui défile traverse en revanche forcément le centre.
  //
  // Effet de bord utile : deux grilles ne tiennent pas ensemble dans cette
  // bande (354 px les séparent, elles font ~383 px chacune pour une bande de
  // ~431 px), et une grille hors bande ne tourne pas. Elles ne peuvent donc
  // plus basculer à l'unisson — le déphasage qui servait à l'éviter a été
  // retiré, il ne faisait plus qu'attarder la seconde grille.
  var ROOT_MARGIN = "-25% 0px -25% 0px";

  var GRID = ".tile-grid";
  var ITEM = ".tile-grid__item";
  var FACE = ".tile-grid__face";
  var CURRENT = "tile-grid__face--current";

  document.addEventListener("DOMContentLoaded", function () {
    // Rotation entièrement neutralisée si l'utilisateur a demandé
    // moins d'animations : la grille reste sur son état initial.
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    Array.prototype.forEach.call(document.querySelectorAll(GRID), setup);
  });

  function setup(grid) {
    // Une case sans seconde face n'a rien à alterner : on l'ignore
    // plutôt que de la faire clignoter sur elle-même.
    var items = Array.prototype.filter.call(
      grid.querySelectorAll(ITEM),
      function (item) {
        return item.querySelectorAll(FACE).length > 1;
      }
    );
    if (!items.length) return;

    var startTimer = null;
    var loopTimer = null;

    // Le nombre de colonnes est lu dans le CSS calculé : la vague suit
    // donc la grille réelle, sans dupliquer les breakpoints ici.
    function columns() {
      var tracks = getComputedStyle(grid).gridTemplateColumns;
      return tracks.split(" ").length;
    }

    function flip(item) {
      var faces = item.querySelectorAll(FACE);
      var current = item.querySelector("." + CURRENT) || faces[0];
      var position = Array.prototype.indexOf.call(faces, current);
      var next = faces[(position + 1) % faces.length];

      current.classList.remove(CURRENT);
      next.classList.add(CURRENT);
    }

    function wave() {
      var cols = columns();

      items.forEach(function (item, i) {
        // Diagonale : toutes les cases à égale distance du coin
        // haut-gauche basculent ensemble.
        var distance = Math.floor(i / cols) + (i % cols);
        item.style.setProperty("--tile-delay", distance * STEP + "ms");
        flip(item);
      });
    }

    function start() {
      if (startTimer || loopTimer) return;
      startTimer = setTimeout(function () {
        startTimer = null;
        wave();
        loopTimer = setInterval(wave, CYCLE);
      }, FIRST_WAVE);
    }

    function stop() {
      clearTimeout(startTimer);
      clearInterval(loopTimer);
      startTimer = null;
      loopTimer = null;
    }

    // Hors de la bande de lecture, la rotation est inutile : elle
    // consommerait de la batterie sur mobile pour une animation que
    // personne ne regarde.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start();
          else stop();
        });
      },
      { rootMargin: ROOT_MARGIN }
    );
    observer.observe(grid);
  }
})();
